// extracted by mini-css-extract-plugin
export default {"base":"form_base__aQiw7"};